<template>
  <span v-if="number > 1">
    {{ $t("et") }} {{ number - 1 }}
    <template v-if="number === 2">
      {{ textSingle || $t("autre numéro") }}
    </template>
    <template v-else>
      {{ textMultiple || $t("autres numéros") }}
    </template>
  </span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  number: number;
  textSingle?: string;
  textMultiple?: string;
}>(), { textSingle: null,textMultiple: null, })
</script>

<style scoped>

</style>
